<template>
  <div class="split-screen w-full h-full">
    <div class="flex items-center h-36px bg-[#262525]">
      <!-- 标题 -->
      <el-tooltip :content="dialogForm.fileName" placement="top" :open-delay="500">
        <div class="w-[calc(100%-36px)] text-white header pl-10px flex-shrink-0 truncate">
          {{ dialogForm.fileName }}
        </div>
      </el-tooltip>
      <!-- 关闭弹窗 -->
      <div
        class="
        bg-[#ff0000]
          text-white
          w-36px
          h-36px
          iconfont
          icon-line-close
          text-center
          leading-36px
          ml-10px
          cursor-pointer
        "
        @click="close"
      ></div>
    </div>
    <div class="w-full h-[calc(100%-36px)]">
      <fileView
        :dialogForm="dialogForm"
        :player="player"
        :standardId="standardId"
        @svgTrigger="svgTrigger"
      />
    </div>
  </div>
</template>

<script>
import fileView from './fileView'

export default {
  name: 'splitScreen',
  components: { fileView },
  props: {
    dialogForm: {
      type: Object,
      defalut: '',
    },
    player: {
      type: Object,
      default: () => {},
    },
    standardId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    svgTrigger(val) {
      this.$emit('svgTrigger', val)
    },
    // 关闭对话框
    close() {
      this.$emit('closeObjectFileSplit')
    },
  },
}
</script>

<style lang="scss" scoped></style>
